import {EventEmitter, Injectable} from '@angular/core';

/**
 * Default Angular injection
 */
@Injectable({
  providedIn: 'root'
})
export class PleaseWaitService {

  progressiveWaiting = false;
  progressiveTotal = 1;
  progressiveCurrent = 0;
  onProgressEvent = new EventEmitter<number>();

  waiting = false;
  enquedOperations = 0;

  /**
   * Default ctor
   */
  constructor() {
  }

  startProgressive(total: number) {
    this.progressiveCurrent = 0;
    this.progressiveWaiting = true;
    this.progressiveTotal = total;
  }

  increaseTotalProgressive(increaseBy: number) {
    this.progressiveTotal += increaseBy;
  }

  advanceProgressive() {
    this.progressiveCurrent++;
    this.onProgressEvent.emit((this.progressiveCurrent / this.progressiveTotal) * 100);
    if (this.progressiveCurrent >= this.progressiveTotal) {
      this.progressiveCurrent = this.progressiveTotal;
      this.progressiveWaiting = false;
    }
  }

  addToQueue() {
    this.waiting = true;
    this.enquedOperations++;
  }

  removeFromQueue() {
    this.enquedOperations--;
    if (this.enquedOperations <= 0) {
      this.enquedOperations = 0;
      this.waiting = false;
    }
  }
}
